import { routes } from '@ui/routes';
import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { ContentManagers } from '../components/ContentManagers';
import { Soap } from '../components/Soap';

export const AdminRoutes = () => (
  <Switch>
    <Route exact path={routes.adminManagers} component={ContentManagers} />
    <Route exact path={routes.adminSoap} component={Soap} />
    <Redirect to={routes.adminManagers} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/Routes/AdminRoutes.tsx